import RawIcon from './RawIcon'

export default RawIcon
